export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9971.47c2992b.jpg";